import cn from "classnames";
import styles from "./index.module.scss";

const BannerRoot = ({ children, className, showCloseButton, onClose }) => {
  return (
    <div className={cn(styles.modal, className)}>
      {showCloseButton && (
        <button className={styles.close} onClick={onClose}>
          <img src="/svgs/icons/close.svg" alt="modal-close" />
        </button>
      )}
      {children}
    </div>
  );
};

export default BannerRoot;
